export default "__VITE_ASSET__DuH55p9W__"